/**
 * Generated by orval v8.2.0 🍺
 * Do not edit manually.
 * Fragment Payments API
 * REST API for Fragment payment operations
 * OpenAPI spec version: 1.0.0
 */

/**
 * Operation type - add a new line item
 */
export type AddLineItemOperationOp = (typeof AddLineItemOperationOp)[keyof typeof AddLineItemOperationOp];

export const AddLineItemOperationOp = {
  add: 'add',
} as const;
